// extracted by mini-css-extract-plugin
export default {"stat-card-total-icon":"UserManagementDashboard_stat-card-total-icon__P7+VY","individual-stat-card-icon":"UserManagementDashboard_individual-stat-card-icon__Gl2SL"};